import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import { RouteConfig } from "vue-router/types/router";

export const ticketsRoutes = (startTemplate: string): RouteConfig[] => {
    return  [{
        path: startTemplate + '/tickets',
        component: () => import(/* webpackChunkName: "ticketSystem" */ '../../views/ticket/TicketSystemView.vue'),
        children: [
            {
                path: 'ideas',
                name: RouteNamesEnum.ticketSystemIdeas,
                meta: {
                    analyticName: 'TicketIdeas'
                },
                children: [
                    {
                        path: 'create',
                        name: RouteNamesEnum.ticketSystemIdeaCreate,
                        meta: {
                            analyticName: 'ticketSystemIdeaCreate'
                        }
                    },
                    {
                        path: ':id/edit',
                        name: RouteNamesEnum.ticketSystemIdeaEdit,
                        meta: {
                            analyticName: 'TicketIdeaEdit'
                        }
                    },
                    {
                        path: ':id',
                        name: RouteNamesEnum.ticketSystemIdeaView,
                        meta: {
                            analyticName: 'TicketIdeaView'
                        }
                    },
                ]
            },
            {
                path: 'problems',
                name: RouteNamesEnum.ticketSystemProblems,
                meta: {
                    analyticName: 'TicketProblems'
                },
                children: [
                    {
                        path: 'create',
                        name: RouteNamesEnum.ticketSystemProblemCreate,
                        meta: {
                            analyticName: 'ticketSystemProblemCreate'
                        }
                    },
                    {
                        path: ':id/edit',
                        name: RouteNamesEnum.ticketSystemProblemEdit,
                        meta: {
                            analyticName: 'TicketProblemEdit'
                        }
                    },
                    {
                        path: ':id',
                        name: RouteNamesEnum.ticketSystemProblemView,
                        meta: {
                            analyticName: 'TicketProblemView'
                        }
                    },
                ]
            },
            {
                path: 'dashboard',
                name: RouteNamesEnum.ticketSystemDashboard,
                meta: {
                    analyticName: 'TicketDashboard'
                },
            }
        ]
    }];
}
